import {
    LOGIN_REQUEST,
    LOGIN_ERROR,
    LOGIN_SUCCESS,
    LOGOUT,
    GET_AUTHENTICATED_USER_REQUEST,
    GET_AUTHENTICATED_USER_SUCCESS
} from "../../Actions/EndUser/AuthActions";
import { auth } from "../../../services";

let email = auth.getAuthUserEmail();
const initialState = {
    authenticated: email ? true : false,
    authenticating: false,
    loginError: '',
    email,
    user: {},
    loading: false
}

export const authentication = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                authenticating: true,
                authenticated: false,
                email: action.payload,
                loginError: ''
            }
        case LOGIN_ERROR: 
            return {
                ...state,
                authenticating: false,
                authenticated: false,
                loginError: action.payload
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                authenticating: false,
                authenticated: true,
                email: action.payload,
                user: {},
            }
        case LOGOUT:
            return {
                ...state,
                authenticated : false,
                authenticating : false,
                email : '',
                user: {}
            }
        case GET_AUTHENTICATED_USER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GET_AUTHENTICATED_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload
            }
        default:
            return state;
    }
}